import React from 'react';
import { useTranslation } from 'react-i18next';
import './AboutPage.css';

import flaubertImage from '../images/FlaubertPhoto.jpg';
import gillesImage from '../images/GillesPhoto.jpg';
import christianImage from '../images/ChristianPhoto.jpg';
import corineImage from '../images/CorinePhoto.jpeg';
import antoineImage from '../images/AntoinePhoto.jpg';
import carlosImage from '../images/CarlosPhoto.jpg';
import marcelineImage from '../images/MarcelinePhoto.jpg';
import robertImage from '../images/RobertPhoto.jpg';
import emileImage from '../images/EmilePhoto.jpg';
export default function AboutPage() {
  const { t } = useTranslation();

  // Liste des membres du bureau — la clé `postKey` pointe vers le libellé
  // du poste dans fr.json / en.json (menu.<postKey>).
  const membres = [
    { nom: 'Jean Flaubert Mougou', image: flaubertImage, postKey: 'president' },
    { nom: 'Gilles Mbiagna', image: gillesImage, postKey: 'vicepresident' },
    { nom: 'Christian Njeumen', image: christianImage, postKey: 'secretary' },
    { nom: 'Corine Ngassam', image: corineImage, postKey: 'treasurer' },
    { nom: 'Antoine Ngoyou', image: antoineImage, postKey: 'communication' },
    { nom: 'Carlos', image: carlosImage, postKey: 'auditor' },
    { nom: 'Marceline Ndatet', image: marcelineImage, postKey: 'discipline' },
    { nom: 'Robert Njakou', image: robertImage, postKey: 'welcoming' },
    { nom: 'Émile Tchaptchet', image: emileImage, postKey: 'honorary' },

  ];

  return (
    <div className="about-page">
      {/* En-tête */}
      <header className="about-hero">
        <h1>{t('menu.aboutTitle')}</h1>
        <p className="about-subtitle">{t('menu.aboutSubtitle')}</p>
      </header>

      {/* Grille des membres du bureau, centrée, 3 colonnes */}
      <section className="about-grid">
        {membres.map((membre) => (
          <div className="profile-card" key={membre.nom}>
            <img
              className="profile-photo"
              src={membre.image}
              alt={membre.nom}
              width={220}
              height={220}
            />
            <h2 className="profile-nom">{membre.nom}</h2>
            <p className="profile-poste">{t(`menu.${membre.postKey}`)}</p>
          </div>
        ))}
      </section>
    </div>
  );
}
